import { TextareaProps } from '@chakra-ui/react';
import { ReactNode } from 'react';
import {
  FieldValues,
  useController,
  UseControllerProps
} from 'react-hook-form';
import { Textarea } from '../../atoms';
import { FormField, FormFieldProps } from './form-field';

export type FieldTextareaProps<FieldValuesType extends FieldValues> = {
  label: string;
  textareaProps?: TextareaProps;
} & FormFieldProps &
  UseControllerProps<FieldValuesType>;

export function FieldTextarea<
  FieldValuesType extends FieldValues = FieldValues
>({
  name,
  rules,
  defaultValue,
  textareaProps,
  ...rest
}: FieldTextareaProps<FieldValuesType>): ReactNode {
  const { field, fieldState } = useController({ name, rules, defaultValue });

  return (
    <FormField
      error={fieldState.error}
      name={name}
      isRequired={!!rules?.required}
      {...rest}
    >
      <Textarea
        id={name}
        onChange={field.onChange}
        {...textareaProps}
        isRequired={!rules?.required}
        onBlur={field.onBlur}
        value={field.value}
      />
    </FormField>
  );
}
